export default "__VITE_ASSET__BnlRUUaE__"